import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import {getUrlPushWrapper} from '../../../routes'
import {hideLoader, showLoader} from '../../../modules/actions'
import {RightsWrapper} from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllDirectCall extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    userGroupsArr: []
  }

  handleSubmit = e => {
    const {dispatch, form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        Request.callInitiate(values)
          .then(({data, error, message}) => {
              if (!error) {
                  notification.success({
                      message: message
                  })
              } else {
                  notification.error({
                      message: message
                  })
              }
          })
      }
    })
  }
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

  componentWillMount() {
    
  }

  async componentDidMount() {
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
  }
  render() {
    const {dispatch} = this.props
    const {
      form: {getFieldDecorator, setFieldsValue}
    } = this.props
    const {userGroupsArr, id} = this.state;

    const inputTypes = {
      fields: [
        {
          label: "Mobile Number",
          key: "mobile",
          type: "number",
          required: true,
          style: { width: 190 },
          parser : (value) => value.substring(0, 10)
        },
      ]
    };
    return (
      <PageHeaderWrapper title={` Direct Call `}>
        <Card bordered={true}>
          <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
            <GetAllFormFields
              inputSchema={inputTypes}
              refresh={this.refreshFxn}
              getFieldDecorator={getFieldDecorator}
            />
            <Button
              type=""
              htmlType="submit"
              style={{
                marginBottom: 10,
                marginLeft: '33%',
                backgroundColor: 'green',
                color: 'white'
              }}
              loading={this.props.loading}>
              Start Call
            </Button>
            <Button
              type="primary"
              style={{marginBottom: 10, marginLeft: '1%'}}
              loading={this.props.loading}
              onClick={() => {
                this.props.form.resetFields()
              }}>
              RESET
            </Button>
          </Form>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllDirectCall
